module.exports = __webpack_public_path__ + "img/tema-1-6.a122da18.svg";